import { render, staticRenderFns } from "./ContactInfo2.vue?vue&type=template&id=cad0957a&scoped=true&"
import script from "./ContactInfo2.vue?vue&type=script&lang=ts&"
export * from "./ContactInfo2.vue?vue&type=script&lang=ts&"
import style0 from "./ContactInfo2.vue?vue&type=style&index=0&id=cad0957a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad0957a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCol,VImg,VRow,VSpacer,VTab,VTabItem,VTabs,VToolbar})
